const state={
    isLogin : false,//目前是否已登入
    accessToken : '',//登入的TOKEN
}

const getters={

}

const mutations={
    //設定登入狀態
    "auth/setLogin" : function(state,value){
        state.isLogin = value;
    },
    //設定登入憑證
    "auth/setAccessToken" : function(state,token){
        state.accessToken = token;
    }
}

const actions={

}

export default{
    state,
    getters,
    mutations,
    actions,
}